import {useMutation} from '@apollo/client';
import Toast from 'utils/Alert/Toast/Toast';
import Modal from 'utils/Modal/Modal';
import CustomSpinner from 'utils/CustomSpinner/CustomSpinner';
import {SECONDARY, SUCCESS} from '../../../../constants';
import {DELETE_PORTFOLIO_REPORT} from 'api/mutations/PortfolioReport';
import {getError} from 'utils/helpers';

const DeletePortfolioReportModal = ({toggle, id}) => {
    const [deletePortfolioReport, {loading}] = useMutation(DELETE_PORTFOLIO_REPORT, {
        refetchQueries: ['PortfolioAggregate'],
        onCompleted: () => {
            Toast({
                msg: 'Report deleted successfully',
                position: 'top-right',
                variant: SUCCESS,
            });
            toggle();
        },
        onError: error => Toast({msg: getError(error), position: 'top-right'}),
    });

    return (
        <Modal type={SECONDARY} show={true} title="Delete Report?" toggle={toggle}>
            <div className="text-center text--large-sm text--gray px-5">
                Are you sure you want to delete this Report?
            </div>
            <div className="flex__between flex-wrap pt-5">
                <div className="col-sm-6 col-12 mt-3">
                    <div className="col-sm-11 col-12">
                        <button
                            disabled={loading}
                            onClick={toggle}
                            className="btn btn--lg btn--primary fw-bold"
                        >
                            No
                        </button>
                    </div>
                </div>
                <div className="col-sm-6 col-12 flex__end mt-3">
                    <div className="col-sm-11 col-12">
                        <button
                            disabled={loading}
                            onClick={() => deletePortfolioReport({variables: {id}})}
                            className="btn btn--lg btn--danger--bordered fw-bold"
                        >
                            {loading ? <CustomSpinner cls="btn--danger--bordered" /> : 'Yes'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeletePortfolioReportModal;
